import {
    DadosPedidoFornecedorActionsTypes,
    type DadosPedidoFornecedorActions,
} from "./dadosPedidoFornecedorActions"
import type { DadosPedidoFornecedorModel } from "../models/dadosPedidoFornecedorModel"
import { DadosPedidoFornecedorInicial } from "../models/dadosPedidoFornecedorModel"

export function dadosPedidoFornecedorReducer(
    state: DadosPedidoFornecedorModel,
    action: DadosPedidoFornecedorActions
): DadosPedidoFornecedorModel {
    switch (action.type) {
        case DadosPedidoFornecedorActionsTypes.DEFINIR_FILTRO:
            return { ...state, filtro: { ...state.filtro, ...action.payload } }
        case DadosPedidoFornecedorActionsTypes.CARREGAR_RESULTADO:
            return { ...state, resultado: action.payload, pagina: 0 }
        case DadosPedidoFornecedorActionsTypes.SET_PAGINA:
            return { ...state, pagina: action.payload }
        default:
            return state
    }
}
